<script>
export default {
  name: 'ContentCard'
}
</script>

<template>
  <div class="content-card">
    <slot name="advertise"/>

    <div class="content-card__form">
      <slot name="form"/>
    </div>
  </div>
</template>

<style scoped>
.content-card {
  position: relative;
  background-color: var(--color-system--white);
  min-height: 100vh;
  width: 100%;
  z-index: var(--z-index-1);
  display: grid;
}

.content-card__form {
  align-self: center;
}

@media (min-width: 400px) {
  .content-card {
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.25);
    border-radius: 20px;
    min-height: 450px;
    max-height: 650px;
    max-width: 384px;
    border-radius: 20px;
    overflow: hidden;
  }
}

@media (min-width: 1000px) {
  .content-card {
    max-width: 928px;
    grid-auto-columns: 1fr;
    grid-auto-flow: column;
    width: auto;
  }

  .content-card__form {
    min-width: 384px;
  }
}
</style>
